import type { ReactNode } from "react";
import { Card, CardTitle, cn } from "@fox1ck-org/ui";

/**
 * A titled block of the campaign card (доски CSummary … CSettings): the
 * package's `Card` with one header row — the title on the left, a caption or
 * the block's own control on the right — and the body under a rule. Every
 * panel of the card is this one; none draws its own border.
 */
export function Panel({
  title,
  aside,
  children,
  className,
  bodyClassName,
}: {
  title: ReactNode;
  aside?: ReactNode;
  children: ReactNode;
  className?: string;
  bodyClassName?: string;
}) {
  return (
    <Card className={cn("min-w-0 overflow-hidden shadow-none", className)}>
      <header className="flex min-h-11 shrink-0 items-center gap-3 border-b border-border px-3.5 py-2">
        <CardTitle className="truncate">{title}</CardTitle>
        <div className="flex-1" />
        {aside}
      </header>
      <div className={cn("flex min-h-0 flex-1 flex-col", bodyClassName)}>{children}</div>
    </Card>
  );
}

/** The muted caption a panel header carries on its right («люди без ботов»). */
export function Aside({ children }: { children: ReactNode }) {
  return <span className="truncate text-xs text-muted-foreground">{children}</span>;
}
